import React, { PureComponent } from "react";
import VisibilitySensor from "react-visibility-sensor";

import styles from "./Dashboard.local.scss";
import classnames from "classnames";
import _ from "i18n";
import { TTP_ACCOUNTING_URL } from "Config";

import { financialConvert } from "Utils";

export default class DashboardComponent extends PureComponent {
  state = {
    listElement: null
  };

  componentDidMount() {
    setTimeout(() => {
      const listElement = document.getElementById("dashboards-list");
      this.setState({ listElement });
    });
  }

  loadMore = isVisible => {
    const { dashboards } = this.props;
    if (!isVisible || (dashboards && dashboards.length === 1)) {
      return;
    }

    if (this.props.loadMore) {
      this.props.loadMore();
    }
  };

  displayIframe(data, e) {
    if (!data.uen || data.dashboardId === 0) {
      return false;
    }

    const { community } = this.props;
    const { uen, name } = data;

    document
      .getElementById("dashboard-iframe")
      .setAttribute(
        "src",
        `${TTP_ACCOUNTING_URL}/embed/dashboard/${uen}/3?organization_id=${
          community.id
        }`
      );
    document
      .getElementById("dashboardSeeMore")
      .setAttribute("href", `${TTP_ACCOUNTING_URL}/dashboard/${uen}`);

    let items = document.getElementsByClassName(styles.item);

    for (let i = 0; i < items.length; i++) {
      items[i].classList.remove(styles.activated);
    }
    e.currentTarget.classList.add(styles.activated);

    $("#dashboard-infos")
      .find("strong")
      .text(name);
    $("#dashboard-infos")
      .find("." + styles.dashInfos)
      .css("display", "flex");
  }

  displayLinks(uen) {}

  renderFetching() {
    const { fetching } = this.props;

    if (!fetching) {
      return;
    }

    return (
      <React.Fragment>
        <li className={classnames("grid-x", styles.item, styles.fetching)}>
          <span />
        </li>
        <li className={classnames("grid-x", styles.item, styles.fetching)}>
          <span />
        </li>
        <li className={classnames("grid-x", styles.item, styles.fetching)}>
          <span />
        </li>
        <li className={classnames("grid-x", styles.item, styles.fetching)}>
          <span />
        </li>
        <li className={classnames("grid-x", styles.item, styles.fetching)}>
          <span />
        </li>
        <li className={classnames("grid-x", styles.item, styles.fetching)}>
          <span />
        </li>
      </React.Fragment>
    );
  }

  renderDashboards() {
    const { dashboards = [] } = this.props;

    return (
      <ul id="dashboards-list">
        {dashboards.map(dash => {
          const { organization, financialRatios, dashboard } = dash;

          const { uen, abbreviation, name } = organization;

          const helpName = abbreviation ? abbreviation : name;
          return (
            <li
              key={uen + helpName}
              className={classnames("grid-x", styles.item)}
              onClick={this.displayIframe.bind(this, {
                uen,
                name: helpName,
                dashboardId: dashboard && dashboard.id ? dashboard.id : 0
              })}
            >
              <div className={styles.points}>
                <i
                  className={classnames("icon icon-options-vertical")}
                  onClick={this.displayLinks.bind(this, uen)}
                />
                <ul className={styles.links}>
                  <li>
                    <a
                      href={`https://data.be/en/company/${uen}`}
                      target="_blank"
                    >
                      <img src="/img/external-icons/data_be-logo.png" alt="" />Data.be
                    </a>
                  </li>
                  <li>
                    <a
                      href={`https://kbopub.economie.fgov.be/kbopub/zoeknummerform.html?lang=fr&nummer=${uen}&actionLu=Recherche`}
                      target="_blank"
                    >
                      <img
                        src="/img/external-icons/crossroads_bank_for_companies-logo.png"
                        alt=""
                      />
                      {_("Crossroads Bank for Companies")}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`http://www.ejustice.just.fgov.be/cgi_tsv/tsv_rech.pl?language=${
                        this.props.lng
                      }&btw=${uen}&liste=Liste`}
                      target="_blank"
                    >
                      <img
                        src="/img/external-icons/spf_justice-logo.png"
                        alt=""
                      />
                      {_("SPF Justice")}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`https://cri.nbb.be/bc9/web/catalog?lang=F&companyNr=${uen}`}
                      target="_blank"
                    >
                      <img
                        src="/img/external-icons/national_bank-logo.png"
                        alt=""
                      />
                      {_("National Bank")}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`https://www.socialsecurity.be/app014/wrep/rep_gp.do?language=fr&REP_KEY_VALUE=${uen}&ACCESS_TYPE=0&ACTION=1&REP_KEY_TYPE=12&REP_LIMIT_DATE=`}
                      target="_blank"
                    >
                      <img
                        src="/img/external-icons/social_security-logo.png"
                        alt=""
                      />
                      {_("Social Security")}
                    </a>
                  </li>
                </ul>
              </div>
              <span
                className={classnames(
                  "cell small-3",
                  styles.organization,
                  styles.lenght
                )}
              >
                <span className={styles.info}>
                  {helpName}
                  <br />
                  <span>BE {uen}</span>
                </span>
              </span>

              <span className="cell small-3">
                {financialRatios && financialRatios.year
                  ? `${_("Rations of")} : ${financialRatios.year}`
                  : "-"}
              </span>
              <span
                className={classnames(
                  "cell small-2",
                  styles.center,
                  styles.stats
                )}
              >
                {financialRatios && financialRatios.profitabilityRatio ? (
                  <span
                    className={classnames(
                      styles.profitability,
                      financialRatios.profitabilityRatioPercentage &&
                      parseFloat(
                        financialRatios.profitabilityRatioPercentage
                      ) >= 0
                        ? styles.blue
                        : styles.red
                    )}
                  >
                    <span className={styles.value}>
                      € {financialConvert(financialRatios.profitabilityRatio)}
                    </span>
                    <br />
                    <span className={classnames(styles.percent)}>
                      {financialRatios.profitabilityRatioPercentage
                        ? financialRatios.profitabilityRatioPercentage + " %"
                        : "-"}
                    </span>
                  </span>
                ) : (
                  <span className={styles.profitability}>-</span>
                )}
              </span>
              <span
                className={classnames(
                  "cell small-2",
                  styles.center,
                  styles.stats
                )}
              >
                {financialRatios && financialRatios.solvencyRatio ? (
                  <span
                    className={classnames(
                      financialRatios.solvencyRatioPercentage &&
                      parseFloat(financialRatios.solvencyRatioPercentage) >= 0
                        ? styles.blue
                        : styles.red
                    )}
                  >
                    <span className={styles.value}>
                      {financialRatios.solvencyRatio}
                    </span>
                    <br />
                    <span className={classnames(styles.percent)}>
                      {financialRatios.solvencyRatioPercentage
                        ? financialRatios.solvencyRatioPercentage + " %"
                        : "-"}
                    </span>
                  </span>
                ) : (
                  "-"
                )}
              </span>
              <span
                className={classnames(
                  "cell small-2",
                  styles.center,
                  styles.stats
                )}
              >
                {financialRatios && financialRatios.liquidityRatio ? (
                  <span
                    className={classnames(
                      financialRatios.liquidityRatioPercentage &&
                      parseFloat(financialRatios.liquidityRatioPercentage) >= 0
                        ? styles.blue
                        : styles.red
                    )}
                  >
                    <span className={styles.value}>
                      {financialRatios.liquidityRatio}
                    </span>
                    <br />
                    <span className={classnames(styles.percent)}>
                      {financialRatios.liquidityRatioPercentage
                        ? financialRatios.liquidityRatioPercentage + " %"
                        : "-"}
                    </span>
                  </span>
                ) : (
                  "-"
                )}
              </span>
            </li>
          );
        })}

        {this.renderFetching()}
        {this.renderVisibilitySensore()}
      </ul>
    );
  }

  renderVisibilitySensore = () => {
    if (!this.state.listElement || !this.props.hasMore || this.props.fetching) {
      return;
    }

    return (
      <VisibilitySensor onChange={this.loadMore}>
        {({ isVisible }) => (
          <li
            className={classnames("grid-x", styles.item)}
            style={{ visibility: "hidden" }}
          >
            <span className="cell small-4" style={{ height: "1.5rem" }}>
              VisibilitySensor is {isVisible ? "visible" : "invisible"}
            </span>
          </li>
        )}
      </VisibilitySensor>
    );
  };

  render() {
    return (
      <div className="grid-x">
        <div className="cell small-12 medium-6">
          <div className={classnames(styles.dashboard)}>
            <div className={classnames(styles.details)}>
              <div className={classnames(styles.header, "grid-x")}>
                <span className="cell small-3">{_("Organisation")}</span>
                <span className="cell small-3">{_("Date")}</span>
                <span className={classnames("cell small-2", styles.center)}>
                  {_("Profitability")}
                </span>
                <span className={classnames("cell small-2", styles.center)}>
                  {_("Solvency")}
                </span>
                <span className={classnames("cell small-2", styles.center)}>
                  {_("Liquidity")}
                </span>
              </div>
              {this.renderDashboards()}
            </div>
          </div>
        </div>
        <div
          className={classnames("cell small-12 medium-6", styles.dash)}
          id="dashboard-infos"
        >
          <div className={styles.dashInfos}>
            <span>
              {_("Dashboard of")} <strong />
            </span>
            <a id="dashboardSeeMore" href="" target="_blanck">
              {_("See more")}
            </a>
          </div>
          <div className={styles.details}>
            <div className={styles.iframeContainer}>
              <iframe src="" title="dashboard" id="dashboard-iframe" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/WorkPlace/Dashboard/DashboardComponent.js